module.exports = __webpack_public_path__ + "static/media/changes-in-my-life.9bf08e16.svg";